import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { Actions_Trailers } from 'redux/modules/trailers/Actions'
import { I18nModal } from 'utils/i18n/i18nModal'

export const useTrailerDeleteFromTrailersList = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.trailerDeleteFromTrailersList)

  const trailerId = useSelector(({ modals }: TState) => modals.data.id)

  const onSubmit = useCallback(() => {
    dispatch(Actions_Trailers.saga.deleteTrailerFromTrailersList({ id: trailerId }))
    dispatch(Actions_Modals.store.hideModal())
  }, [dispatch, trailerId])

  const onCancel = useCallback(() => dispatch(Actions_Modals.store.hideModal()), [dispatch])

  return { t, onSubmit, onCancel }
}
